const data = {
  fastcompany: {
    logo:
      '//a.fastcompany.net/image/upload/v1488299125/fc/fastcompany-logo.svg',
    title: 'Fast Company',
    subscribeLink: 'https://magazine.fastcompany.com/loc/FST/summersale',
    newsletterLink: 'https://www.fastcompany.com/newsletters',
    topics: [
      {
        url: '/co-design',
        title: 'Co.Design'
      },
      {
        url: '/technology',
        title: 'Technology'
      },
      {
        url: '/leadership',
        title: 'Leadership'
      },
      {
        url: '/entertainment',
        title: 'Entertainment'
      },
      {
        url: '/ideas',
        title: 'Ideas'
      },
      {
        url: '/videos',
        title: 'Video'
      },
      {
        url: '/news',
        title: 'News'
      }
    ]
  }
};

export default data;
